<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[items$]"></ef-loading-container>
<ef-customer-admin-presenter
[items]="items$ | async"
[advisors]="advisors$ | async"
[userInfo]="userInfo$ | async"
[states]="states$ | async"
(UpdateCompanyInfo)="onUpdateCompanyInfo($event)"
(UpdateAdvisor)="onUpdateAdvisor($event)"
>
</ef-customer-admin-presenter>
<!-- <div class="w-100">
    <p-message *ngIf="this.showUpdateMessage == true" severity="success" text="Update Complete"></p-message>
    <p-message *ngIf="this.showUpdateFailedMessage == true" severity="error" text="Update Failed"></p-message>
</div> -->
